import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find";
import Module from '@/components/base/Module/Module.vue';
// import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue'
import Title from '@/components/base/Title/Title';
import WelfareItem from '@/components/item/WelfareItem/WelfareItem.vue';
import VerticalList from '@/components/base/VerticalList/VerticalList.vue';
import HorizontalScroll from '@/components/base/HorizontalScroll/HorizontalScroll.vue';
import BaseItem from '@/components/item/BaseItem/BaseItem.vue';
import beautifyNumber from '@/mixin/filters/beautifyNumber';
import TipWording from "./TipWording/TipWording.vue";
import GiftModal from "./GiftModal/GiftModal.vue";
import OpenMod from "./OpenMod/OpenMod.vue";
import { LeafType } from '@/util/const';
var GiftType = {
  Gift: 1,
  // 弹窗礼包类型
  Wording: 2 // 在专属福利标题下方的图标文字类型(wording类型)
};

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    welfare: {
      type: Object,
      required: true
    },
    id: {}
  },
  data: function data() {
    return {
      belongsList: [],
      currentLevelList: []
    };
  },
  created: function created() {
    this.initList();
  },
  filters: {
    beautifyNumber: beautifyNumber
  },
  computed: {
    // 专属福利，下一等级福利每行展示数量
    rowItemNum: function rowItemNum() {
      var enums = {
        vft_regular: 2,
        // 普通屏幕
        vft_large: 3,
        // 折叠屏
        vft_huge: 4,
        // ipad
        vft_max: 5 // ipad pro
      };

      return enums[this.deviceSize];
    },
    ip: function ip() {
      return this.welfare.tUserInfo.sIp;
    },
    platform: function platform() {
      return this.welfare.tUserInfo.iPlatForm;
    },
    isVip: function isVip() {
      return this.welfare.iVipStatus === 3;
    },
    currentLevel: function currentLevel() {
      return this.welfare.iVipLevel;
    },
    openVipMod: function openVipMod() {
      return this.welfare.vModList.find(function (item) {
        return item.data.tModDescInfo.sZtLeafType === LeafType.Discounts;
      });
    },
    levelMod: function levelMod() {
      return this.welfare.vModList.find(function (item) {
        return item.data.tModDescInfo.sZtLeafType === LeafType.LevelWelfare;
      });
    },
    // 专属福利模块
    belongsMod: function belongsMod() {
      return this.welfare.vModList.find(function (item) {
        return item.data.tModDescInfo.sZtLeafType === LeafType.BelongsWelfare;
      });
    },
    // 专属礼包模块
    giftMod: function giftMod() {
      return this.welfare.vModList.find(function (item) {
        return item.data.tModDescInfo.sZtLeafType === LeafType.GiftMod;
      });
    },
    wording: function wording() {
      return this.giftMod && this.giftMod.data.vActList.find(function (item) {
        return item.tActType.iGiftType === GiftType.Wording;
      });
    },
    openVipList: function openVipList() {
      if (this.openVipMod) {
        return this.openVipMod.data.vActList;
      }
      return [];
    },
    // 下一等级列表
    nextLevelList: function nextLevelList() {
      if (this.levelMod) {
        return this.isMounted ? this.levelMod.data.vNextLevelList : this.levelMod.data.vNextLevelList.slice(0, this.rowItemNum);
      }
      return [];
    },
    // 专属福利的更多链接
    subPageInfo: function subPageInfo() {
      var vModIdList = [];
      if (this.belongsMod) {
        vModIdList.push({
          sChannelId: this.belongsMod.data.tModDescInfo.sChannelID,
          sModId: this.belongsMod.data.tModDescInfo.sModId
        });
      }
      if (this.levelMod) {
        vModIdList.push({
          sChannelId: this.levelMod.data.tModDescInfo.sChannelID,
          sModId: this.levelMod.data.tModDescInfo.sModId
        });
      }
      return {
        vModIdList: vModIdList
      };
    },
    forceData: function forceData() {
      var faceData = this.data;
      faceData.tModDescInfo.tJumpInfo.iTitleJumpType = 1;
      return faceData;
    },
    reportParams: function reportParams() {
      return {
        f_module: '专属福利',
        f_module_id: this.id,
        eid: 'module'
      };
    }
  },
  watch: {
    rowItemNum: function rowItemNum() {
      this.initList();
    }
  },
  components: {
    Module: Module,
    TipWording: TipWording,
    GiftModal: GiftModal,
    OpenMod: OpenMod,
    Title: Title,
    VerticalList: VerticalList,
    HorizontalScroll: HorizontalScroll,
    WelfareItem: WelfareItem,
    BaseItem: BaseItem
  },
  methods: {
    initList: function initList() {
      if (this.belongsMod) {
        this.belongsList = this.belongsMod.data.vActList.sort(function (a, b) {
          return a.tActState.iUserGetStatus - b.tActState.iUserGetStatus;
        }).slice(0, this.rowItemNum);
      }
      if (this.levelMod) {
        this.currentLevelList = this.levelMod.data.vActList.sort(function (a, b) {
          return a.tActState.iUserGetStatus - b.tActState.iUserGetStatus;
        }).slice(0, this.rowItemNum);
      }
    },
    openNextLevelItem: function openNextLevelItem() {
      var _this = this;
      this.confirm({
        msg: "\u60A8\u5F53\u524D\u7684\u7B49\u7EA7\u6682\u65F6\u672A\u80FD\u9886\u53D6\u8BE5\u798F\u5229",
        confirmText: '查看升级攻略',
        confirm: function confirm() {
          _this.openUrl('//film.qq.com/weixin/user_grade.html');
        }
      });
    }
  },
  ptag: 'zs',
  reportData: {
    '开通优惠更多': {
      'f_module': '开通优惠',
      'f_resource': '更多',
      'f_type': 4,
      'eid': 'more'
    },
    '专属福利更多': {
      'f_module': '专属福利',
      'f_resource': '更多',
      'f_type': 4,
      'eid': 'more'
    },
    '下一级福利海报': function 下一级福利海报(title, cubeId) {
      return {
        'f_module': '专属福利',
        'f_resource': title + '海报',
        'f_type': 5,
        'f_cubeid': cubeId
      };
    },
    '升级攻略': {
      'f_module': '专属福利',
      'f_resource': '升级攻略',
      'f_type': 4
    }
  }
};